export const ALLOWED_MIME_TYPES_EXCEL = [
  'text/csv',
  'application/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
]

export const ALLOWED_MIME_TYPES_IMAGE = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/webp',
  'image/svg+xml',
  'video/webm',
]

export const ALLOWED_MIME_TYPES_PDF = ['application/pdf']

// Generic attachment whitelist used by property-activities upload (PNG/JPG/PDF only).
export const ALLOWED_MIME_TYPES_ATTACHMENT = ['image/png', 'image/jpeg', 'application/pdf']
export const ALLOWED_FILE_EXT_IMAGE = '.png,.jpg,.jpeg'
export const ALLOWED_FILE_EXT_PDF = '.pdf'
